import { Component, ContentChildren, QueryList, ChangeDetectorRef, ViewEncapsulation, ChangeDetectionStrategy, AfterContentInit, Output, EventEmitter } from '@angular/core';

import { Tab } from '../models/tab';
import { VrcTabComponent } from '../vrc-tab/vrc-tab.component';

@Component({
  selector: 'vrc-tabs',
  templateUrl: './vrc-tabs.component.html',
  styleUrls: ['./vrc-tabs.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VrcTabsComponent implements AfterContentInit {
  @Output() selected = new EventEmitter<string>();
  @ContentChildren(VrcTabComponent) tabs!: QueryList<VrcTabComponent>;
  constructor(private cd: ChangeDetectorRef) { }

  ngAfterContentInit(): void {
    const tab = this.tabs.find((t) => t.active) ?? this.tabs.first;
    this.selectTab(tab);
    this.cd.detectChanges();
  }

  selectTab(tab: Tab): void {
    if (tab) {
      this.reset();
      tab.active = true;
      this.emit(tab);
    }
  }

  private reset(): void {
    this.tabs.map((t: Tab) => t.active = false);
  }

  private emit(tab: any): void {
    if (tab?.label) {
      this.selected.emit(tab.label);
    }
  }
}
